/**
 * Spider house rules.
 *
 * Spider's difficulty is not in the stock or in how much room you have to
 * think — it is in how many suits are in the pack. At one suit every card in
 * sequence is also in suit, so runs always move whole and the game is a gentle
 * puzzle; at four, a run you have carefully built is usually four separate runs
 * that cannot travel together. Same deal, same rules, entirely different game.
 */
export const TABLEAU_COLUMNS = 10;
/** Two packs, however many suits they are drawn from. */
export const DECK_SIZE = 104;
/** Ace through King: what has to be assembled, in suit, to clear a run. */
export const SEQUENCE_LENGTH = 13;
/** Eight of them, and the game is out. */
export const SEQUENCES_TO_WIN = 8;
/** Fifty cards left after the deal, ten at a time. */
export const STOCK_DEALS = 5;
/** Spider is played alone. Stated so the lobby has something to read. */
export const MIN_PLAYERS = 1;
export const MAX_PLAYERS = 1;
const BASE = {
    suitCount: 1,
    allowDealWithEmptyColumn: false,
};
export const RULE_PRESETS = [
    {
        id: 'one',
        name: 'One suit',
        description: 'Spades only. Every sequence you build is already in suit, so runs always move in one piece. The way to learn the game, and winnable most times out.',
        rules: { ...BASE },
    },
    {
        id: 'two',
        name: 'Two suits',
        description: 'Spades and hearts. Now half the cards that will sit on a nine cannot travel with it, and untangling the mixed runs is most of the game.',
        rules: { ...BASE, suitCount: 2 },
    },
    {
        id: 'four',
        name: 'Four suits',
        description: 'The full pack, twice. A tidy-looking column is usually four runs that will not move together, and a deal you can win is a deal you have earned.',
        rules: { ...BASE, suitCount: 4 },
    },
];
/** The set a fresh game starts with. */
export const DEFAULT_RULES = RULE_PRESETS[0].rules;
/**
 * Coerces untrusted input into a valid ruleset. Mirrors `sanitiseRules` in the
 * other three engines: anything unrecognised falls back to the default rather
 * than throwing, so a stale client can never wedge a game.
 *
 * `suitCount` is checked against the three legal values rather than clamped to
 * a range — three suits is not a harder Spider, it is a pack that cannot be
 * dealt into eight equal runs.
 */
export function sanitiseRules(input) {
    const raw = (input ?? {});
    const rules = { ...DEFAULT_RULES };
    if (typeof raw.allowDealWithEmptyColumn === 'boolean') {
        rules.allowDealWithEmptyColumn = raw.allowDealWithEmptyColumn;
    }
    if (raw.suitCount === 1 || raw.suitCount === 2 || raw.suitCount === 4) {
        rules.suitCount = raw.suitCount;
    }
    return rules;
}
//# sourceMappingURL=rules.js.map